import React, { useEffect, useState } from 'react';
import { Accordion, Col, Row, Image, Spinner, Form, Button } from 'react-bootstrap';
import UserService from '../../services/UserService';

const XemThongTinChamCongComponent = () => {
  const [attendanceData, setAttendanceData] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [selectedMonth, setSelectedMonth] = useState(''); // Tháng người dùng chọn

  // Hàm lấy dữ liệu chấm công từ API
  const fetchAttendanceData = async (month, year, recent = false) => {
    setLoading(true); // Bắt đầu trạng thái tải dữ liệu
    try {
      // Nếu recent là true, gọi API mà không truyền month và year
      const response = recent
        ? await UserService.getThongTinChamCong()
        : await UserService.getThongTinChamCong(month, year);

      if (response.success) {
        setAttendanceData(response.data); // Cập nhật dữ liệu chấm công từ API
      } else {
        setErrorMessage(response.message); // Hiển thị lỗi nếu có
      }
    } catch (error) {
      setErrorMessage('Có lỗi xảy ra khi tải dữ liệu chấm công.');
    } finally {
      setLoading(false); // Dừng trạng thái tải
    }
  };

  // Gọi hàm lấy dữ liệu chấm công cho tháng hiện tại khi component được mount lần đầu
  useEffect(() => {
    fetchAttendanceData(null, null, true);  // Gọi API với tháng và năm mặc định
  }, []);

  // Xử lý khi người dùng thay đổi tháng
  const handleMonthChange = (event) => {
    const selected = event.target.value;
    setSelectedMonth(selected); // Cập nhật tháng đã chọn

    if (selected) {
      const [year, month] = selected.split('-'); // Tách tháng và năm từ định dạng yyyy-MM
      fetchAttendanceData(parseInt(month, 10), parseInt(year, 10)); // Gọi API với tháng và năm đã chọn
    }
  };

  // Xử lý khi bấm vào nút "Lần chấm công gần đây"
  const handleRecentCheckInClick = () => {
    setSelectedMonth(''); // Xóa tháng đã chọn
    fetchAttendanceData(null, null, true); // Gọi API để lấy lần chấm công gần đây nhất
  };

  // Hàm để render hình ảnh từ chuỗi base64
  const renderImage = (base64String) => {
    if (base64String) {
      const isAlreadyBase64 = base64String.startsWith('data:image/');
      const validBase64 = isAlreadyBase64 ? base64String : `data:image/png;base64,${base64String}`;
      return <Image src={validBase64} alt="Hình ảnh chấm công" fluid />;
    }
    return <p>Không có hình ảnh</p>;
  };

  // Kiểm tra trạng thái tải dữ liệu
  if (loading) {
    return <Spinner animation="border" variant="primary" />;
  }

  // Hiển thị thông báo lỗi nếu có lỗi
  if (errorMessage) {
    return <p className="text-danger">{errorMessage}</p>;
  }

  return (
    <div>
      <h2 className="text-center">Thông tin chấm công</h2>

      {/* Ô chọn tháng */}
      <Form.Group controlId="monthPicker" className="mb-3">
        <Form.Label>Chọn tháng</Form.Label>
        <Form.Control
          type="month"
          value={selectedMonth}
          onChange={handleMonthChange}
        />
      </Form.Group>

      {/* Nút lấy lần chấm công gần đây */}
      <Button variant="secondary" className="mb-3" onClick={handleRecentCheckInClick}>
        Lần chấm công gần đây
      </Button>

      <Accordion defaultActiveKey="0">
        {attendanceData.length > 0 ? (
          attendanceData.map((day, index) => (
            <Accordion.Item key={index} eventKey={`${index}`}>
              <Accordion.Header>
                <div className="d-flex justify-content-between w-100">
                  {day.vao && day.ra ? (
                    <>
                      <span>Ngày công {index + 1} - {new Date(day.ngay_cong).toLocaleDateString('vi-VN')}</span>
                    </>
                  ) : (
                    <span>Ngày {new Date(day.ngay_cong).toLocaleDateString('vi-VN')}</span>
                  )}
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <Row>
                  {/* Thông tin chấm công "Vào" */}
                  {day.vao ? (
                    <Col md={6}>
                      <h5>Vào ca</h5>
                      <p><strong>Thời gian:</strong> {new Date(day.vao.thoi_gian_cham_cong).toISOString().replace('T', ' ').slice(0, 19)}</p>
                      <p><strong>Địa điểm:</strong> {day.vao.dia_diem_cham_cong || 'Không có thông tin'}</p>
                      <p><strong>Hình ảnh:</strong></p>
                      {renderImage(day.vao.hinh_anh_base64)}
                    </Col>
                  ) : (
                    <></>
                  )}

                  {/* Thông tin chấm công "Ra" */}
                  {day.ra ? (
                    <Col md={6}>
                      <h5>Ra ca</h5>
                      <p><strong>Thời gian:</strong> {new Date(day.ra.thoi_gian_cham_cong).toISOString().replace('T', ' ').slice(0, 19)}</p>
                      <p><strong>Địa điểm:</strong> {day.ra.dia_diem_cham_cong || 'Không có thông tin'}</p>
                      <p><strong>Hình ảnh:</strong></p>
                      {renderImage(day.ra.hinh_anh_base64)}
                    </Col>
                  ) : (
                    <></>
                  )}
                </Row>
              </Accordion.Body>
            </Accordion.Item>
          ))
        ) : (
          <p>Không có dữ liệu cho tháng được chọn.</p>
        )}
      </Accordion>
    </div>
  );
};

export default XemThongTinChamCongComponent;